import { render } from "./SatelliteModal.vue?vue&type=template&id=6e21b5c5&scoped=true"
import script from "./SatelliteModal.vue?vue&type=script&lang=js"
export * from "./SatelliteModal.vue?vue&type=script&lang=js"

import "./SatelliteModal.vue?vue&type=style&index=0&id=6e21b5c5&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e21b5c5"]])

export default __exports__